import React from "react";
import { BrowserRouter, Routes as RouterRoutes, Route } from "react-router-dom";
import ScrollToTop from "components/ScrollToTop";
import ErrorBoundary from "components/ErrorBoundary";
import NotFound from "pages/NotFound";
import RegulatoryCompliance from './pages/regulatory-compliance';
import AdverseEventReporting from './pages/adverse-event-reporting';
import AuditTrailViewer from './pages/audit-trail-viewer';
import BatchTestingRecords from './pages/batch-testing-records';
import QualityDashboard from './pages/quality-dashboard';
import LaboratoryEquipment from './pages/laboratory-equipment';

const Routes = () => {
  return (
    <BrowserRouter>
      <ErrorBoundary>
      <ScrollToTop />
      <RouterRoutes>
        {/* Define your route here */}
        <Route path="/" element={<AdverseEventReporting />} />
        <Route path="/regulatory-compliance" element={<RegulatoryCompliance />} />
        <Route path="/adverse-event-reporting" element={<AdverseEventReporting />} />
        <Route path="/audit-trail-viewer" element={<AuditTrailViewer />} />
        <Route path="/batch-testing-records" element={<BatchTestingRecords />} />
        <Route path="/quality-dashboard" element={<QualityDashboard />} />
        <Route path="/laboratory-equipment" element={<LaboratoryEquipment />} />
        <Route path="*" element={<NotFound />} />
      </RouterRoutes>
      </ErrorBoundary>
    </BrowserRouter>
  );
};

export default Routes;
